import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    phone: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const normalizePhone = (phone) => {
    if (phone.startsWith('+90')) return phone;
    if (phone.startsWith('0')) return `+9${phone}`;
    return `+90${phone}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.phone || !formData.password) {
      setError('Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);

    try {
      const payload = {
        phone: normalizePhone(formData.phone),
        password: formData.password
      };

      const response = await axios.post(`${API}/auth/login`, payload);

      if (!response.data?.token || !response.data?.user) {
        throw new Error('Eksik login response');
      }

      login(response.data.token, response.data.user);

      // küçük delay → auth state otursun diye
      setTimeout(() => {
        if (response.data.user.is_admin) {
          navigate('/admin');
        } else {
          navigate('/reservation');
        }
      }, 100);

    } catch (err) {
      console.error('Login error:', err);

      const backendError =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.error;

      setError(
        backendError ||
        'Giriş başarısız. Telefon veya şifre hatalı.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div style={{ maxWidth: '520px', margin: '0 auto', paddingTop: '60px' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '900',
            background: 'linear-gradient(135deg, #ff0000 0%, #8B0000 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}>
            Giriş Yap
          </h1>
          <p style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
            PWR Rezervasyon Sistemine Hoş Geldiniz.
          </p>
        </div>

        <div className="card">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Telefon Numarası</label>
              <input
                type="text"
                name="phone"
                className="input-field"
                placeholder="5xxxxxxxxx"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Şifre</label>
              <input
                type="password"
                name="password"
                className="input-field"
                placeholder="Şifreniz"
                value={formData.password}
                onChange={handleChange}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Giriş yapılıyor...' : '🎟️ Giriş Yap'}
            </button>
          </form>

          <div style={{ marginTop: '28px', textAlign: 'center' }}>
            <p style={{ color: 'rgba(255,255,255,0.7)' }}>
              Hesabınız yok mu?{' '}
              <Link to="/register" className="link">
                Kayıt Ol
              </Link>
            </p>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-secondary" onClick={() => navigate('/')}>
            ← Ana Sayfaya Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
